import {getQuery} from "@/modules/common/utils";
import paginationUtil from "@/modules/common/utils/paginationUtil";
import {MIN_INSTALLMENT_AMOUNT} from "@/modules/payments/utils/linkedPlanUtil";

const list = async (params) => getQuery('payment_statuses', params)
const get = uid => getQuery(`payment_statuses/${uid}`);

const listAll = async (baseParams) => {
  const fetchPageFn = async (params) => {
    const response = await getQuery('payment_statuses', params);
    return response.data || [];
  };
  return paginationUtil.fetchAllPages(fetchPageFn, baseParams);
};

const fetchOpenPaymentRequests = async (matterUid, baseParams = {}) => {
  const params = {
    new_api: true,
    'filter[matter_uid][eq]': matterUid,
    'filter[state][in]': 'DUE,OVERDUE',
    'filter[entity_type][in]': 'Meeting,EventAttendance,ProductOrder,ClientBookingPackage',
    'filter[amount_pending][lte]': 0,
    'filter[display]': true,
    sort: 'created_at:asc',
    per_page: 30,
    ...baseParams,
  };
  
  const fetchPageFn = async (pageParams) => {
    const response = await getQuery('/business/payments/v1/payment_requests', pageParams);
    return response.data?.payment_requests || [];
  };
  return paginationUtil.fetchAllPages(fetchPageFn, params);
};

// by_amount_left_to_pay is the balance expression the server validates a linked plan against, so
// asking for its minimum installment leaves only invoices a plan can actually be built on.
// Scoped to one matter and to open invoices, this is a single page in every realistic case - what
// makes payment_statuses expensive is a business-wide read across every client, not this.
const fetchOpenInvoices = async (clientUid, matterUid) => {
  const fetchPageFn = async (params) => {
    const response = await list(params);
    return response.data || [];
  };
  return paginationUtil.fetchAllPages(fetchPageFn, {
    per_page: 30,
    client: clientUid,
    conversation_id: matterUid,
    by_type: 'Invoice',
    by_status: 'outstanding,past_due',
    by_amount_left_to_pay: MIN_INSTALLMENT_AMOUNT,
    sort_by: 'created_at:desc',
  });
};

export default {
  list,
  listAll,
  get,
  fetchOpenPaymentRequests,
  fetchOpenInvoices,
}
